// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import store from './store/store'
import router from './router'
import VueWorker from 'vue-worker'
import locale from 'element-ui/lib/locale/lang/en'
import Mixpanel from './plugins/mixpanel'
import BadRequestInterceptor from './plugins/interceptors/bad_request'
import UnauthorizedRequestInterceptor from './plugins/interceptors/unauthorized_request'
import AuthVerifier from './plugins/authverification/auth_verifier'
// import InstanceSwitchGuard from './plugins/instance_switch_guard'
import PageVisibilityCheck from './plugins/page_visibility_check'
import SigmaPlugin from '@sigmacloud/sigma-client/dist/components/plugins/sigma'
import { enableIgnoreVueWarn } from '@sigmacloud/sigma-client/dist/components/plugins'
import { IS_DEV } from '@sigmacloud/sigma-client/dist/util/env'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'element-ui/lib/theme-default/index.css'
import './assets/styles/main.css'

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
Vue.use(VueResource)
Vue.use(VueWorker)
Vue.use(Mixpanel, { token: process.env.MIXPANEL_TOKEN || '' })
Vue.use(BadRequestInterceptor)
Vue.use(UnauthorizedRequestInterceptor)
Vue.use(AuthVerifier)
// Vue.use(InstanceSwitchGuard)
Vue.use(PageVisibilityCheck)
Vue.use(SigmaPlugin)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

if (IS_DEV) {
  enableIgnoreVueWarn(Vue)
}

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
}).$mount('#app')

if (process.env.DD_APPLICATION_ID && process.env.DD_CLIENT_TOKEN) {
  router.onReady(() => {
    window.DD_RUM.init({
      applicationId: process.env.DD_APPLICATION_ID,
      clientToken: process.env.DD_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'sigma-frontend',
      env: process.env.DD_ENV,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input'
    })
    window.DD_RUM.startSessionReplayRecording()
    const user = store.getters.getUser
    if (user && user.isLoggedIn) {
      const instanceUrl = sessionStorage.getItem('instanceUrl') || ''
      const instanceName = instanceUrl.replace(/^https?:\/\//i, '').replace(/\/.*$/, '').split('.')[0]
      window.DD_RUM.setUser({ id: user.userId, name: user.username, email: user.email, instance: instanceName })
    }
  })
}



// WEBPACK FOOTER //
// ./src/main.js